import type { InjectionKey } from 'vue';
import type { NormalizedPreconColorsGlobalOptions } from './options';

/**
 * The injection to get the options into the components.
 */
export const preconColorsOptionsInjectionKey = Symbol(
    'precon-colors library options'
) as InjectionKey<Readonly<NormalizedPreconColorsGlobalOptions>>;
